import shuffle from 'lodash/shuffle';
import { Training } from '@/interfaces/class/training';

export default (el: Training) => {
  const { enFillersWrong, enGaps, enSlicesWrong } = el;

  const wrongsSplitted = enFillersWrong || shuffle(enSlicesWrong.split('/'))[0];
  const enFillersArray = enGaps.split('\n').map((gap: string) => gap.split(' ').filter((word: string) => word));
  const enFillersShuffled = enFillersArray[0].concat([wrongsSplitted]).concat(enFillersArray[1]);

  return {
    ...el,
    enFillersShuffled,
    enSlicesSplitted: [...enFillersShuffled],
  };
};
